import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';
import type RouterService from '@ember/routing/router-service';
import type { AuthenticatedSyfRouteModel } from 'tio-employee/routes/authenticated/syf';
import type PersonModel from 'tio-common/models/person';
import type MatchPlanModel from 'tio-common/models/match-plan';
import type MatchParticipantModel from 'tio-common/models/match-participant';

export type AuthenticatedSyfEnrollmentRouteModel = {
  person: PersonModel;
  matchParticipant: MatchParticipantModel;
  matchPlan: MatchPlanModel;
};

export default class AuthenticatedSyfAccountConfirmationRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;
  @service declare router: RouterService;

  beforeModel() {
    const parentModel = this.modelFor('authenticated.syf') as AuthenticatedSyfRouteModel | null;
    if (!parentModel || parentModel.matchParticipant.isEnrolled) {
      this.router.transitionTo('authenticated.syf.dashboard');
    }
  }

  async model() {
    const person = await this.store.findRecord<PersonModel>(
      'person',
      // @ts-expect-error type models
      this.sessionContext.person.id,
      {
        include: 'accounts.financial-institution',
      }
    );
    const parentModel = this.modelFor('authenticated.syf') as AuthenticatedSyfRouteModel;
    const matchParticipant = parentModel.matchParticipant;
    const matchPlan = matchParticipant.matchPlan;
    return { person, matchParticipant, matchPlan };
  }
}
